import { farmbookAxios } from '../../components/config/App/App';
import { IFranchise } from '../../compiler/multiFranchise.interface';
import { isValidFranchiseUuid } from '../axios/franchiseContext';

/** This endpoint derives access from the authenticated actor. Never fall back
 * to the franchise directory: existence does not establish authorization. */
export async function APIGetAccountingFranchises(signal?: AbortSignal): Promise<IFranchise[]> {
  const response = await farmbookAxios.get<IFranchise[]>(
    '/procurement/auth/available-franchises', { signal }
  );
  if (!Array.isArray(response.data)) throw new Error('Invalid available franchises response');
  const seen = new Set<string>();
  return response.data.filter(item => {
    if (!item || item.is_active !== true || !isValidFranchiseUuid(item.uuid)) return false;
    const uuid = item.uuid.toLowerCase();
    if (seen.has(uuid)) return false;
    seen.add(uuid);
    return true;
  }).map(item => ({ ...item, uuid: item.uuid.toLowerCase() }));
}
